module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObject
  }, [_vm._t("left", [(_vm.left) ? _c('div', {
    staticClass: "input-group-addon",
    domProps: {
      "innerHTML": _vm._s(_vm.left)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._t("left", [(_vm.right) ? _c('div', {
    staticClass: "input-group-addon",
    domProps: {
      "innerHTML": _vm._s(_vm.right)
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28db802d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/input-group.vue
// module id = 230
// module chunks = 0